import { configs } from '../../app/app-configs';
import { KeyValuePair } from '../../model/key-value-pair';
import { Pagination } from '../../model/pagination';
import { User } from './user.model';

export interface Note {
    id: number;
    content: string;
    status: string;
    creatorName: string;
    creatorId: number;
    targetType: string;
    targetId: number;
    targetName: string;
    dueDate: string;
    createdOn: string;
    updatedOn: string;
}

export interface NoteCreateRequest {
    content: string;
    targetType: string;
    targetId: number;
    dueDate: string;
}

export interface NoteUpdateRequest {
    id: number;
    content: string;
    status: string;
    dueDate: string;
}

export interface NoteSummary {
    total: number;
    openCount: number;
    overdueCount: number;
    dueTodayCount: number;
    countByStatus: KeyValuePair<number>[];
}

export interface NoteRequest {
    id?: number;
    content: string;
    status: string;
    creator?: User;
    targetType: string;
    targetId: number;
    targetName: string;
    dueDate: string;
}

export interface ExpiringNote {
    noteId: number;
    content: string;
    targetType: string;
    targetName: string;
    createdBy: string;
}

export interface MemberSummaryNote {
    noteId: number;
    content: string;
    dueDate: string;
    createdOn: string;
}

export interface NoteSearchCriteria {
    pagination: Pagination;
    targetId?: number;
    // from: string;
    // to: string;
    // name: string;
}

export const getDefaultNoteSearchCriteria = (): NoteSearchCriteria => {
    return {
        pagination: { page: 0, size: configs.PAGE_SIZE },
        // name: '',
        // from: addDays(new Date(), -7).toISOString().slice(0, 10),
        // to: new Date().toISOString().slice(0, 10),
    };
};
